/**
 * Opciones de material para autocompletar: nombre y, en la segunda línea, el código.
 * @param {Array<Object>} articles Artículos de inventario.
 * @returns {Array<{value: string, label: string, secondary: string}>}
 */
export const toArticleOptions = (articles = []) =>
  articles.map((article) => ({
    value: article.uuid,
    label: article.name || article.code || '',
    secondary: article.name ? article.code || '' : '',
  }));
